import * as React from "react";
import { VersionCard } from "../VersionCard";
import { QueryStateBoundary } from "@/components/dashboard/QueryStateBoundary";
import { useVersion, useBuildInfo } from "@/hooks/queries/useSystemInfo";
import { FRONTEND_VERSION } from "@/utils/frontendVersion";

interface VersionPayload {
  data: { application_version: string; environment: string };
}

interface BuildInfoPayload {
  data: { build_version: string };
}

/** Reuses Sprint 3.1's `useVersion`/`useBuildInfo` hooks rather than duplicating them. */
export function ApplicationSection(): React.JSX.Element {
  const versionQuery = useVersion();
  const buildInfoQuery = useBuildInfo();

  return (
    <QueryStateBoundary query={versionQuery}>
      {(versionPayload) => {
        const version = versionPayload as unknown as VersionPayload;
        return (
          <QueryStateBoundary query={buildInfoQuery}>
            {(buildPayload) => {
              const build = buildPayload as unknown as BuildInfoPayload;
              return (
                <VersionCard
                  metrics={[
                    { label: "Backend Version", value: version.data?.application_version },
                    { label: "Frontend Version", value: FRONTEND_VERSION },
                    { label: "Build Version", value: build.data?.build_version },
                    { label: "Environment", value: version.data?.environment },
                  ]}
                />
              );
            }}
          </QueryStateBoundary>
        );
      }}
    </QueryStateBoundary>
  );
}
